export class PositionTabsAdd {
    constructor(optionalOptions = {}) {
        function hideAllSub() {
            if ($('.base-area-tabs--content:not(.base-area-tabs--first)').length > 0) {
                $('.base-area-tabs--content:not(.base-area-tabs--first)').find('.base-form--select--to-disable .nice-select').prop('disabled', true).niceSelect('update');
            }
        }

        $(document).ready(function(){
            hideAllSub()
        });

        $(document).on("click", '.base-area-tabs--header .base-area-tabs-header--item', function(event) {
            if ($(this).hasClass('active') || $(this).hasClass('add')) {
                return;
            }

            $(this).addClass('active').siblings().removeClass('active')

            let contentId = $(this).attr('data-content');
            if (contentId) {
                $(this).closest('.base-area--tabs').find('.base-area-tabs--content').removeClass('active');
                $('#'+contentId).addClass('active');
            }
        });

        $('.base-area-tabs-header--item.add').on('click', function (event) {
            let id = window.uniqId('tab')
            let itemName = $(this).closest('.base-area--tabs').attr('data-header-item-name');
            let template = $(this).closest('.base-area--tabs').attr('data-body-template');
            $(this).before($(this).clone().removeClass('add').html(itemName).attr('data-content', id));
            let clonnedContent = $(template).find('.base-area-tabs--content').clone();
            clonnedContent.attr('id', id);
            //clonnedContent.find('.base-form--select--to-disable .nice-select').prop('disabled', true).niceSelect('update');
            $(this).closest('.base-area--tabs').find('.base-area-tabs--body').append(clonnedContent.attr('id', id))

            hideAllSub();

            setTimeout(() => $('.base-area-tabs--header .base-area-tabs-header--item[data-content="' + id + '"]').click(), 300);
        });

        $(document).on("change", '.base-area--tabs .base-area-tabs--first .base-form--select--to-disable .nice-select', function(event) {
            $('.base-area-tabs--content:not(.base-area-tabs--first) .base-form--select--to-disable .nice-select').val($(this).val()).niceSelect('update');
            $('.base-area--tabs .base-form--value input').change();
        })

        $(document).on("change", '.base-area--tabs .base-form--value input', function(event) {
            let selectVal = $('.base-area-tabs--content.base-area-tabs--first .base-form--select--to-disable .nice-select').val();
            let id = $(this).closest('.base-area-tabs--content').attr('id');
            $('.base-area-tabs-header--item[data-content="' + id + '"]').html($(this).val() + ' ' + selectVal)
        })

        $(document).on("click", '.base-area-tabs--content.active .base-area-tabs--remove', function(event) {
            event.preventDefault();
            let id = $(this).closest('.base-area-tabs--content').attr('id');
            $('.base-area-tabs-header--item[data-content="' + id + '"]').remove();
            $(this).closest('.base-area-tabs--content').remove();

            $('.base-area-tabs-header--first').click();
        })
    }

    destructor() {
    }
}

export default new PositionTabsAdd();
